import { Badge } from "@/components/ui/badge";
import { Sparkles } from "lucide-react";

interface NewBadgeProps {
  className?: string;
}

export const NewBadge = ({ className = "" }: NewBadgeProps) => {
  return (
    <Badge 
      className={`bg-primary text-primary-foreground hover:bg-primary/90 flex items-center gap-1 px-2 py-1 text-xs font-semibold shadow-sm ${className}`}
    >
      <Sparkles className="h-3 w-3" />
      Ny
    </Badge>
  );
};
